import React from "react";
import styles from "./Dashboard.module.css";

export default function MetricsCards({ data }) {
  if (!data) {
    return <div className={styles.metricsSection}>Loading metrics...</div>;
  }

  const metrics = [
    {
      title: "Total",
      title2: "Purchases",
      value: `£${data.totalPurchases?.toLocaleString() ?? "0"}`,
      style: styles.metricValue,
    },
    {
      title: "Total",
      title2: "Messages Sent",
      value: data.totalMessagesSent?.toLocaleString() ?? "0",
      style: `${styles.metricValue} ${styles.sendMessage}`,
    },
    {
      title: "Total",
      title2: "Messages Received",
      value: data.totalMessagesReceived?.toLocaleString() ?? "0",
      style: `${styles.metricValue} ${styles.receivedMessage}`,
    },
    {
      title: "New Consumers",
      title2: "Registered",
      value: data.newConsumersRegistered ?? "0",
      style: styles.metricValue,
    },
    {
      title: "Reply Time",
      title2: "> 15 Minutes",
      value: `${data.replyTimeOver15Min?.toLocaleString() ?? "0"}  `,
      style: `${styles.metricValue} ${styles.negativeValue}`,
    },
  ];

  return (
    <div className={styles.metricsSection}>
      <div className={styles.metricsCards}>
        {metrics.map((metric, index) => (
          <div key={index} className={styles.metricCard}>
            <h3>
              {metric.title} <br />
              {metric.title2}
            </h3>
            <p className={metric.style}>{metric.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
